import React, { useState } from 'react'
import './ModTextInputMinimal.css'

export default function ModTextInputMinimal({
  label,
  value,
  required,
  onChange,
  placeholder,
  type = 'text',
  maxLength,
  ...props
}) {
  const [focused, setFocused] = useState(false)

  return (
    <label className='mod-text-input-minimal'>
      {label && (
        <span className='mod-text-input-minimal__label'>
          {label}
          {required && <span className='mod-text-input-minimal__asterisk'>*</span>}
        </span>
      )}
      <div className='mod-text-input-minimal__wrapper'>
        <input
          className='mod-text-input-minimal__input'
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          {...props}
        />
        <div className={`mod-text-input-minimal__underline ${focused ? 'mod-text-input-minimal__underline--focused' : ''}`} />
      </div>
    </label>
  )
}
